module.exports = __webpack_public_path__ + "images/trello-enterprise-with-text.c44c457cc4c18c2cb7d1.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/trello-enterprise-with-text.png
// module id = jVzC
// module chunks = 1